<div class="card bg-light">


  <br />
  <br />
  <br />
  <div class="row">
      <div class=col-md-2>
          &nbsp;
      </div>
      <div class="col-md-8" style="text-align:center">
          <h4>
              Assessment Appeals Management Studio
          </h4>
      </div>
  </div>
  <div class="row">
    <div class="col-md-8 offset-2" style="text-align: center; color: blue;"><h5>{{environ}}</h5></div>
</div>
  <br />
  <div class="row">
      <div class=col-md-2>
          &nbsp;
      </div>
      <div class="col-md-8" style="text-align:center">

          <img src="../assets/sbseal-clear.png" alt="County Seal" height="200" width="204.66">
      </div>
      <div class=col-md-2>
          &nbsp;
      </div>
  </div>
  <br />

  <div class="row">
      <div class=col-md-2>
          &nbsp;
      </div>
      <div class=col-md-8 style="text-align:center">
          <h5>Clerk of the Board</h5>
      </div>
      <div class=col-md-2>
          &nbsp;
      </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <div class="row" *ngIf="isAdmin==true;">
    <div class="col-md-5 offset-3" style="text-align: right;">
      <h5>Number of cases which are due to expire within the next six months:</h5>
    </div>
    <div *ngIf="runningExpCases==true" class="col-md-2">
      <p-progressSpinner [style]="{width: '50px', height: '30px', margin: '0px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner>
    </div>

    <div class="col-md-3" *ngIf="numExpiringCases>-1" style="font-weight: bold; text-align: left;">{{numExpiringCases}}</div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <footer class="main-footer" style="text-align:center; font-size:small; margin-bottom: 5px">
      <span >Copyright &copy; {{copyYear}} - Parodan, LLC. All Rights Reserved.</span>
      <span style="font-size: x-small">&nbsp; v. {{version}}</span>
  </footer>
  <p-messages key="info"></p-messages>
  <p-toast key="toast" [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
</div>


